import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServerSentEventService {
  getEventSource(url: URL): EventSource {
    // @ts-ignore
    return new EventSource(url);
  }
}
